module.exports = __webpack_public_path__ + "static/bluesafari3-e2af790e2c45067c2903b571d3f11897.jpeg";